<template>
  <modal v-cloak v-model="modalVisible" size="lg" :title="actionTitle()" @show="onShow" :footer="false">
    <div class="row row-margin">
      <div class="col-sm-12">
        <error-list v-if="errorObject" :error-object="errorObject"/>

        <form v-show="submitted == 0" @submit.prevent.stop="submit">

          <div class="row">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group" :class="{ 'has-error': $v.address.countryID.$error }">
                    <label>Country</label>
                    <select class="form-control input-sm" v-model.number="address.countryID">
                      <option v-bind:value="null">-- select country --</option>
                      <option v-for="option in options.countries" v-bind:value="option.countryID">
                        {{ option.countryname }}
                      </option>
                    </select>
                    <span v-show="$v.address.countryID.$error" class="help-block">Please select a country.</span>
                  </div>
                </div>
              </div>
              <div class="form-group" :class="{ 'has-error': $v.address.firstname.$error || $v.address.lastname.$error }">
                <label>Name</label>
                <div class="row">
                  <div class="col-xs-6">
                    <input type="text" v-model.trim="address.firstname" class="form-control input-sm" placeholder="First Name">
                  </div>
                  <div class="col-xs-6">
                    <input type="text" v-model.trim="address.lastname" class="form-control input-sm" placeholder="Last Name">
                  </div>
                </div>
                <span v-show="$v.address.firstname.$error || $v.address.lastname.$error" class="help-block">Please enter your name.</span>
              </div>
              <div class="form-group">
                <label>Company</label>
                <input type="text" v-model.trim="address.company" class="form-control input-sm" placeholder="Company" >
              </div>
              <div class="row">
                <div class="col-xs-6 col-sm-12 col-md-6">
                  <div class="form-group" :class="{ 'has-error': $v.address.daytimephone.$error }">
                    <label>Phone</label>
                    <input type="tel" v-model.trim="address.daytimephone" maxlength="20" class="form-control input-sm"  placeholder="Phone">
                    <span v-show="$v.address.daytimephone.$error" class="help-block">Please enter your phone number.</span>
                  </div>
                </div>
                <div class="col-xs-6 col-sm-12 col-md-6">
                  <p class="help-block">note: your phone number will only be used to contact you about orders you place.</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" style="margin-bottom:5px;" :class="{ 'has-error': $v.address.address1.$error }">
                <label>Address</label>
                <input type="text" v-model.trim="address.address1" maxlength="29" class="form-control input-sm" placeholder="Address">
                <span v-show="$v.address.address1.$error" class="help-block">Please enter your address.</span>
              </div>
              <div class="form-group" style="margin-bottom:5px;">
                <input type="text" v-model.trim="address.address2" maxlength="29" class="form-control input-sm" placeholder="Address (cont)" >
              </div>
              <div class="form-group">
                <input type="text" v-model.trim="address.address3" maxlength="29" class="form-control input-sm" placeholder="Address (cont)" >
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group" :class="{ 'has-error': $v.address.city.$error }">
                    <label>City</label>
                    <input type="text" v-model.trim="address.city" class="form-control input-sm" placeholder="City">
                    <span v-show="$v.address.city.$error" class="help-block">Please enter your city.</span>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div v-show="address.countryID === 1" class="form-group" :class="{ 'has-error': $v.address.stateID.$error }">
                    <label>State</label>
                    <select class="form-control input-sm" v-model.number="address.stateID">
                      <option v-bind:value="null">-- select state --</option>
                      <option v-for="option in options.states" v-bind:value="option.stateID">
                        {{ option.statecode }}
                      </option>
                    </select>
                    <span v-show="$v.address.stateID.$error" class="help-block">Please select your state.</span>
                  </div>
                  <div v-show="address.countryID !== 1" class="form-group">
                    <label>Province</label>
                    <input type="text" v-model.trim="address.province" maxlength="50" class="form-control input-sm" placeholder="Province" >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group" :class="{ 'has-error': $v.address.zip.$error }">
                    <label><span class="zip-label">Postal code</span></label>
                    <input type="text" v-model.trim="address.zip" maxlength="10" class="form-control input-sm" placeholder="Postal code">
                    <span v-show="$v.address.zip.$error" class="help-block">Please enter your postal code.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <button type="submit" class="btn btn-primary btn-text pull-right">Save</button>
          <div class="clearfix"></div>
        </form>
        <div class="vue-modal-success" v-show="submitted == 1">Processing...</div>
      </div>
    </div>
  </modal>
</template>

<style scoped>
</style>

<script>
import axios from 'axios'
import { Modal } from 'uiv'
import { required } from 'vuelidate/lib/validators'
import ErrorList from "../ErrorList"
import { ErrorListMixin }  from '../../mixins/ErrorListMixin'
import { ModalMixin } from '../../mixins/ModalMixin'
import { jrNotifyEx } from '../../bootstrap'

function validState(value) {
    return value || this.countryID !== 1
}

function validZip(value) {
    const optionalPostalCode = [ 218,9,12,16,223,224,30,226,227,228,229,299,231,232,49,233,56,289,61,236,66,318,239,75,79,240,84,87,280,97,244,298,300,110,249,250,120,121,127,305,306,144,152,259,176,177,316,212,163,261,311,264,169,183,187,189,320,319,321,192,322,272,199,203,276,278 ]
    return value || $.inArray(parseInt(this.countryID), optionalPostalCode) >= 0
}


export default {
    components: {
        'error-list': ErrorList,
        'modal': Modal,
    },

    mixins: [ErrorListMixin, ModalMixin],

    props: {
        modalName: {
            type: String,
            default: 'editAddress'
        },
    },

    data () {
        return {
            options: {
                countries: [],
                states: [],
            },
            address: {
                accountaddressID: null,
                countryID: 1,
                firstname: null,
                lastname: null,
                company: null,
                daytimephone: null,
                address1: null,
                address2: null,
                address3: null,
                city: null,
                stateID: null,
                province: null,
                zip: null,
            },
        }
    },

    validations: {
        address: {
            countryID: {required,},
            firstname: {required,},
            lastname: {required,},
            daytimephone: {required,},
            address1: {required,},
            city: {required,},
            stateID: {validState,},
            zip: {validZip,},
        }
    },

    async created () {
        try {
            const response = await axios.get('/account-address/options')
            this.options = response.data.data
        } catch (e) {
            jrNotifyEx(e, e.response)
        }
    },

    methods: {
        prepSubmission: function () {
            this.$v.$reset()
            this.prepErrorList()
        },

        onShow: function () {
            this.errorObject = null
            this.address = this.$store.state.modals.accountAddress
            this.prepSubmission()
        },

        submit: async function () {
            this.$v.$touch()
            if (!this.$v.$error) {
                const self = this
                this.postAndErrorCheck(
                    '/account-address/save',
                    this.address,
                    function(data) {
                        self.modalVisible = false
                        self.$emit('save', data)
                    },
                    this.prepSubmission
                )
            }
        },

        actionTitle: function () {
            return this.address.accountaddressID ? 'Edit Address' : 'Add Address'
        },
    },
}
</script>
